/*
=============================================
LEHJA - India's First Classical Art Lifestyle Brand
Main JavaScript
Author: Hiraya Digital
Version: 1.0
=============================================
*/

(function() {
    'use strict';

    // =============================================
    // LENIS SMOOTH SCROLL
    // =============================================
    let lenis;

    function initLenis() {
        lenis = new Lenis({
            duration: 1.2,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            orientation: 'vertical',
            gestureOrientation: 'vertical',
            smoothWheel: true,
            wheelMultiplier: 1,
            touchMultiplier: 2,
            infinite: false,
        });

        window.lenisInstance = lenis;

        function raf(time) {
            lenis.raf(time);
            requestAnimationFrame(raf);
        }
        requestAnimationFrame(raf);

        // Integrate with GSAP ScrollTrigger
        lenis.on('scroll', ScrollTrigger.update);

        gsap.ticker.add((time) => {
            lenis.raf(time * 1000);
        });

        gsap.ticker.lagSmoothing(0);
    }

    // =============================================
    // GSAP REGISTRATION
    // =============================================
    function initGSAP() {
        gsap.registerPlugin(ScrollTrigger);
        
        gsap.defaults({
            ease: 'power3.out',
            duration: 0.8
        });
    }

    // =============================================
    // HEADER SCROLL EFFECT
    // =============================================
    function initHeader() {
        const header = document.getElementById('header');
        const mobileMenu = document.getElementById('mobileMenu');

        if (!header) return;

        ScrollTrigger.create({
            start: 'top -80',
            onUpdate: (self) => {
                if (self.scroll() > 80) {
                    header.classList.add('scrolled');
                    if (mobileMenu) mobileMenu.classList.add('scrolled-header');
                } else {
                    header.classList.remove('scrolled');
                    if (mobileMenu) mobileMenu.classList.remove('scrolled-header');
                }
            }
        });
    }

    // =============================================
    // MEGA MENU DYNAMIC IMAGES
    // =============================================
    function initMegaMenu() {
        const megamenus = document.querySelectorAll('.megamenu');

        megamenus.forEach(megamenu => {
            const menuImage = megamenu.querySelector('.megamenu-image');
            const menuLinks = megamenu.querySelectorAll('.megamenu-list li a[data-image]');

            if (!menuImage || menuLinks.length === 0) return;

            const defaultImage = menuImage.src;

            menuLinks.forEach(link => {
                link.addEventListener('mouseenter', function() {
                    const newImage = this.getAttribute('data-image');
                    if (newImage && newImage !== menuImage.src) {
                        // Crossfade effect
                        gsap.to(menuImage, {
                            opacity: 0,
                            duration: 0.15,
                            onComplete: () => {
                                menuImage.src = newImage;
                                gsap.to(menuImage, {
                                    opacity: 1,
                                    duration: 0.15
                                });
                            }
                        });
                    }
                });
            });

            // Reset to default on mouse leave from megamenu
            megamenu.addEventListener('mouseleave', () => {
                if (menuImage.src !== defaultImage) {
                    gsap.to(menuImage, {
                        opacity: 0,
                        duration: 0.15,
                        onComplete: () => {
                            menuImage.src = defaultImage;
                            gsap.to(menuImage, {
                                opacity: 1,
                                duration: 0.15
                            });
                        }
                    });
                }
            });
        });
    }

    // =============================================
    // HERO ANIMATIONS
    // =============================================
    function initHeroAnimations() {
        if (!document.querySelector('.hero')) return;

        const tl = gsap.timeline({ delay: 0.3 });

        tl.to('.hero-tagline', {
            opacity: 1,
            y: 0,
            duration: 0.8
        })
        .to('.hero-title', {
            opacity: 1,
            y: 0,
            duration: 0.8
        }, '-=0.5')
        .to('.hero-subtitle', {
            opacity: 1,
            y: 0,
            duration: 0.8
        }, '-=0.5')
        .to('.hero-description', {
            opacity: 1,
            y: 0,
            duration: 0.8
        }, '-=0.5')
        .to('.cta-group', {
            opacity: 1,
            y: 0,
            duration: 0.8
        }, '-=0.5')
        .to('.hero-image-main', {
            opacity: 1,
            scale: 1,
            duration: 1
        }, '-=0.8')
        .to('.hero-image-accent', {
            opacity: 1,
            x: 0,
            duration: 0.8
        }, '-=0.6')
        .to('.floating-feather', {
            opacity: 0.6,
            duration: 0.6
        }, '-=0.4');
    }

    // =============================================
    // SCROLL REVEAL ANIMATIONS
    // =============================================
    function initScrollReveal() {
        // Standard reveal (fade up)
        gsap.utils.toArray('.reveal').forEach(elem => {
            gsap.to(elem, {
                scrollTrigger: {
                    trigger: elem,
                    start: 'top 85%',
                    toggleActions: 'play none none none'
                },
                opacity: 1,
                y: 0,
                duration: 0.8
            });
        });

        // Reveal from left
        gsap.utils.toArray('.reveal-left').forEach(elem => {
            gsap.to(elem, {
                scrollTrigger: {
                    trigger: elem,
                    start: 'top 85%',
                    toggleActions: 'play none none none'
                },
                opacity: 1,
                x: 0,
                duration: 0.8
            });
        });

        // Reveal with scale
        gsap.utils.toArray('.reveal-scale').forEach(elem => {
            gsap.to(elem, {
                scrollTrigger: {
                    trigger: elem,
                    start: 'top 85%',
                    toggleActions: 'play none none none'
                },
                opacity: 1,
                scale: 1,
                duration: 0.8
            });
        });
    }

    // =============================================
    // STAGGERED CARD ANIMATIONS
    // =============================================
    function initCardAnimations() {
        // Collection cards
        if (document.querySelectorAll('.collection-card').length > 0) {
            ScrollTrigger.batch('.collection-card', {
                onEnter: batch => gsap.to(batch, {
                    opacity: 1,
                    scale: 1,
                    duration: 0.6,
                    stagger: 0.15,
                    ease: 'power3.out'
                }),
                start: 'top 85%'
            });
        }

        // Award cards
        if (document.querySelectorAll('.award-card').length > 0) {
            ScrollTrigger.batch('.award-card', {
                onEnter: batch => gsap.to(batch, {
                    opacity: 1,
                    scale: 1,
                    duration: 0.6,
                    stagger: 0.1,
                    ease: 'power3.out'
                }),
                start: 'top 85%'
            });
        }

        // Audience cards
        if (document.querySelectorAll('.audience-card').length > 0) {
            ScrollTrigger.batch('.audience-card', {
                onEnter: batch => gsap.to(batch, {
                    opacity: 1,
                    y: 0,
                    duration: 0.5,
                    stagger: 0.08,
                    ease: 'power3.out'
                }),
                start: 'top 85%'
            });
        }
    }

    // =============================================
    // TEXT REVEAL – staggered word-by-word on scroll
    // =============================================
    function initTextReveal() {
        var headings = document.querySelectorAll(
            '.section-title, .awards-title, .bestsellers-title, .founder-title, .philosophy-title, .audience-title'
        );

        headings.forEach(function(heading) {
            // Remove the generic reveal so it doesn't double-animate
            heading.classList.remove('reveal');

            // Split innerHTML into HTML tags vs text, wrap each word
            var parts = heading.innerHTML.split(/(<[^>]*>)/);
            heading.innerHTML = parts.map(function(p) {
                if (p.charAt(0) === '<') return p;  // keep tags as-is
                return p.replace(/(\S+)/g,
                    '<span class="word-wrap" style="display:inline-block;overflow:hidden;vertical-align:bottom;padding-bottom:0.08em">' +
                    '<span class="word-inner" style="display:inline-block">$1</span></span>');
            }).join('');

            // Override the .reveal initial hidden state
            heading.style.opacity = '1';
            heading.style.transform = 'none';

            var words = heading.querySelectorAll('.word-inner');
            gsap.set(words, { yPercent: 110 });

            ScrollTrigger.create({
                trigger: heading,
                start: 'top 85%',
                onEnter: function() {
                    gsap.to(words, {
                        yPercent: 0,
                        duration: 0.8,
                        stagger: 0.04,
                        ease: 'power3.out'
                    });
                },
                once: true
            });
        });
    }

    // =============================================
    // PARALLAX EFFECTS
    // =============================================
    function initParallax() {
        // Floating feather
        const feather = document.querySelector('.floating-feather');
        if (feather) {
            gsap.to(feather, {
                scrollTrigger: {
                    trigger: '.hero',
                    start: 'top top',
                    end: 'bottom top',
                    scrub: 1
                },
                y: 100,
                rotation: 15,
                ease: 'none'
            });
        }

        // Hero curves
        const heroCurves = document.querySelector('.hero-curves');
        if (heroCurves) {
            gsap.to(heroCurves, {
                scrollTrigger: {
                    trigger: '.hero',
                    start: 'top top',
                    end: 'bottom top',
                    scrub: 1
                },
                y: 50,
                ease: 'none'
            });
        }

        // Founder decoration
        const founderDecoration = document.querySelector('.founder-decoration');
        if (founderDecoration) {
            gsap.to(founderDecoration, {
                scrollTrigger: {
                    trigger: '.founder-story',
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: 1
                },
                y: -50,
                rotation: 10,
                ease: 'none'
            });
        }
    }

    // =============================================
    // MOBILE MENU
    // =============================================
    function initMobileMenu() {
        const menuToggle = document.getElementById('menuToggle');
        const mobileMenu = document.getElementById('mobileMenu');
        const header = document.querySelector('.header');
        const mobileNavItems = document.querySelectorAll('.mobile-nav-item');
        const mobileNavLinks = document.querySelectorAll('.mobile-nav-link, .mobile-nav-content a, .mobile-nav-group a');

        if (!menuToggle || !mobileMenu) return;

        // Toggle mobile menu
        menuToggle.addEventListener('click', function() {
            this.classList.toggle('active');
            mobileMenu.classList.toggle('active');
            header.classList.toggle('menu-open');

            if (mobileMenu.classList.contains('active')) {
                lenis.stop();
                document.body.style.overflow = 'hidden';
            } else {
                lenis.start();
                document.body.style.overflow = '';
            }
        });

        // Mobile accordion
        mobileNavItems.forEach(item => {
            const toggle = item.querySelector('.mobile-nav-toggle');
            if (toggle) {
                toggle.addEventListener('click', function() {
                    // Close other items
                    mobileNavItems.forEach(otherItem => {
                        if (otherItem !== item) {
                            otherItem.classList.remove('active');
                        }
                    });
                    // Toggle current item
                    item.classList.toggle('active');
                });
            }
        });

        // Close on link click
        mobileNavLinks.forEach(link => {
            link.addEventListener('click', () => {
                menuToggle.classList.remove('active');
                mobileMenu.classList.remove('active');
                header.classList.remove('menu-open');
                lenis.start();
                document.body.style.overflow = '';
            });
        });

        // Close on resize
        window.addEventListener('resize', () => {
            if (window.innerWidth > 768) {
                menuToggle.classList.remove('active');
                mobileMenu.classList.remove('active');
                header.classList.remove('menu-open');
                lenis.start();
                document.body.style.overflow = '';
            }
        });
    }

    // =============================================
    // NEWSLETTER FORM
    // =============================================
    function initNewsletterForm() {
        const form = document.querySelector('.newsletter-form');
        if (!form) return;

        form.addEventListener('submit', function(e) {
            e.preventDefault();
            
            const input = this.querySelector('.newsletter-input');
            const btn = this.querySelector('.newsletter-btn');
            const email = input.value.trim();

            if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                input.style.borderColor = '#ff4444';
                setTimeout(() => { input.style.borderColor = ''; }, 2000);
                return;
            }

            const originalText = btn.textContent;
            btn.textContent = 'Subscribing...';
            btn.disabled = true;

            // Simulate API call
            setTimeout(() => {
                btn.textContent = 'Subscribed!';
                input.value = '';
                
                setTimeout(() => {
                    btn.textContent = originalText;
                    btn.disabled = false;
                }, 2000);
            }, 1500);
        });
    }

    // =============================================
    // SMOOTH ANCHOR SCROLL
    // =============================================
    function initSmoothAnchors() {
        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function(e) {
                const href = this.getAttribute('href');
                if (href === '#') return;
                
                const target = document.querySelector(href);
                if (target) {
                    e.preventDefault();
                    lenis.scrollTo(target, {
                        offset: -100,
                        duration: 1.2
                    });
                }
            });
        });
    }

    // =============================================
    // LAZY LOADING IMAGES
    // =============================================
    function initLazyLoading() {
        const images = document.querySelectorAll('img[data-src]');
        if (images.length === 0) return;

        const imageObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const img = entry.target;
                    img.src = img.dataset.src;
                    img.removeAttribute('data-src');
                    
                    img.addEventListener('load', () => {
                        img.classList.add('loaded');
                        img.parentElement.classList.add('has-image');
                    });
                    
                    observer.unobserve(img);
                }
            });
        }, { rootMargin: '50px 0px' });

        images.forEach(img => imageObserver.observe(img));
    }

    // =============================================
    // IMAGE CAROUSEL - Automatic Product Image Cycling
    // =============================================
    function initImageCarousels() {
        const carousels = document.querySelectorAll('.card-image-carousel');

        carousels.forEach(carousel => {
            const slides = carousel.querySelectorAll('.card-image-slide');

            // Only initialize if there are multiple slides
            if (slides.length < 2) return;

            let currentIndex = 0;

            function cycleImages() {
                // Remove active class from current slide
                slides[currentIndex].classList.remove('active');

                // Move to next slide
                currentIndex = (currentIndex + 1) % slides.length;

                // Add active class to next slide
                slides[currentIndex].classList.add('active');
            }

            // Start cycling every 3 seconds
            setInterval(cycleImages, 3000);
        });
    }

    // =============================================
    // CART DRAWER
    // =============================================
    function initCartDrawer() {
        const cartDrawer = document.getElementById('cart-drawer');
        const cartOverlay = document.getElementById('cart-drawer-overlay');
        const cartToggleBtns = document.querySelectorAll('[data-cart-drawer-toggle]');
        const cartCloseBtn = document.getElementById('cart-drawer-close');
        const continueShoppingBtn = document.getElementById('cart-drawer-continue');

        if (!cartDrawer || !cartOverlay) return;

        // Open cart drawer
        function openCart() {
            cartDrawer.classList.add('is-open');
            cartOverlay.classList.add('is-visible');
            if (lenis) lenis.stop();
            document.body.style.overflow = 'hidden';
        }

        // Close cart drawer
        function closeCart() {
            cartDrawer.classList.remove('is-open');
            cartOverlay.classList.remove('is-visible');
            if (lenis) lenis.start();
            document.body.style.overflow = '';
        }

        // Cart toggle buttons (header cart icon)
        cartToggleBtns.forEach(btn => {
            btn.addEventListener('click', openCart);
        });

        // Close button
        if (cartCloseBtn) {
            cartCloseBtn.addEventListener('click', closeCart);
        }

        // Overlay click
        cartOverlay.addEventListener('click', closeCart);

        // Continue shopping button
        if (continueShoppingBtn) {
            continueShoppingBtn.addEventListener('click', closeCart);
        }

        // Cart drawer links (don't close drawer)
        const cartLinks = cartDrawer.querySelectorAll('a');
        cartLinks.forEach(link => {
            link.addEventListener('click', function(e) {
                // Only close for checkout/cart page links
                const href = this.getAttribute('href');
                if (href && (href.includes('checkout') || href.includes('/cart'))) {
                    setTimeout(closeCart, 100);
                }
            });
        });

        // ESC key to close
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && cartDrawer.classList.contains('is-open')) {
                closeCart();
            }
        });

        // Remove item functionality
        const removeButtons = cartDrawer.querySelectorAll('.cart-drawer__item-remove');
        removeButtons.forEach(btn => {
            btn.addEventListener('click', function() {
                const line = this.getAttribute('data-line');
                removeCartItem(line);
            });
        });
    }

    // Remove item from cart
    function removeCartItem(line) {
        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                line: line,
                quantity: 0
            })
        })
        .then(response => response.json())
        .then(data => {
            updateCartDrawer(data);
            updateCartCount(data.item_count);
        })
        .catch(error => {
            console.error('Error removing item:', error);
        });
    }

    // Update cart drawer with new data
    function updateCartDrawer(cart) {
        const cartItemsContainer = document.getElementById('cart-drawer-items');
        const cartEmpty = document.getElementById('cart-drawer-empty');
        const cartFooter = document.getElementById('cart-drawer-footer');
        const cartSubtotal = document.getElementById('cart-drawer-subtotal');
        const cartCount = document.getElementById('cart-drawer-count');

        // Update count
        if (cartCount) {
            cartCount.textContent = cart.item_count;
        }

        // Update subtotal
        if (cartSubtotal) {
            cartSubtotal.textContent = formatMoney(cart.total_price);
        }

        // Show/hide empty state
        if (cart.item_count === 0) {
            if (cartEmpty) cartEmpty.style.display = 'flex';
            if (cartItemsContainer) cartItemsContainer.style.display = 'none';
            if (cartFooter) cartFooter.style.display = 'none';
        } else {
            if (cartEmpty) cartEmpty.style.display = 'none';
            if (cartItemsContainer) cartItemsContainer.style.display = 'flex';
            if (cartFooter) cartFooter.style.display = 'block';

            // Rebuild items list
            if (cartItemsContainer) {
                cartItemsContainer.innerHTML = cart.items.map((item, index) => `
                    <div class="cart-drawer__item" data-line="${index + 1}" data-key="${item.key}">
                        <div class="cart-drawer__item-image">
                            ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy" width="80" height="100">` : ''}
                        </div>
                        <div class="cart-drawer__item-details">
                            <a href="${item.url}" class="cart-drawer__item-title">${item.product_title}</a>
                            ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-drawer__item-variant">${item.variant_title}</div>` : ''}
                            <div class="cart-drawer__item-price">${formatMoney(item.final_line_price)}</div>
                            ${item.quantity > 1 ? `<div class="cart-drawer__item-qty">Qty: ${item.quantity}</div>` : ''}
                            <button class="cart-drawer__item-remove" data-line="${index + 1}">Remove</button>
                        </div>
                    </div>
                `).join('');

                // Re-attach event listeners to new remove buttons
                const removeButtons = cartItemsContainer.querySelectorAll('.cart-drawer__item-remove');
                removeButtons.forEach(btn => {
                    btn.addEventListener('click', function() {
                        const line = this.getAttribute('data-line');
                        removeCartItem(line);
                    });
                });
            }
        }
    }

    // Update cart count in header
    function updateCartCount(count) {
        const cartCountElements = document.querySelectorAll('.cart-count');
        cartCountElements.forEach(el => {
            el.textContent = count;
        });
    }

    window.updateCartDrawer = updateCartDrawer;

    function formatMoney(cents) {
        return 'Rs. ' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    // =============================================
    // INITIALIZE
    // =============================================
    function init() {
        initGSAP();
        initLenis();
        initHeader();
        initMegaMenu();
        initHeroAnimations();
        initScrollReveal();
        initTextReveal();
        initCardAnimations();
        initParallax();
        initMobileMenu();
        initCartDrawer();
        initNewsletterForm();
        initSmoothAnchors();
        initLazyLoading();
        initImageCarousels();

        console.log('🎭 Lehja Website Initialized');
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

})();
